import { ConstraintCalendarRestrictionBase } from './base/constraint-calendar-restriction-base';

export class ConstraintCalendarRestriction extends ConstraintCalendarRestrictionBase { }